export enum StatusType {
  Initial = 'INITIAL',
  Loading = 'LOADING',
  Created = 'CREATED',
  Updated = 'UPDATED',
  Deleted = 'DELETED',
  Failure = 'FAILURE',
  Uploaded = 'UPLOADED',
  fileDeleted = 'FILEDELETED',
  TryAgain = 'TRYAGAIN',
}
